import { useState, useRef, useEffect } from "react";
import { IoCaretDownSharp } from "react-icons/io5";
// import closeIcon from "../../../assets/images/close.png";
import "./FilterPanel.css";

export default function FilterPanel({ filters, setFilters, tags, totalJobs }) {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const panelRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (panelRef.current && !panelRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectTag = (tag) => {
    if (!filters.jobCategory.includes(tag)) {
      setFilters({
        ...filters,
        jobCategory: [...filters.jobCategory, tag],
      });
    }
  };

  const handleRemoveTag = (tag) => {
    setFilters({
      ...filters,
      jobCategory: filters.jobCategory.filter((t) => t !== tag),
    });
  };

  const handleResetFilters = () => {
    setFilters({
      ...filters,
      jobCategory: [],
    });
  };

  const filteredTags = tags.filter((tag) =>
    tag.toLowerCase().includes(searchInput.toLowerCase())
  );

  return (
    <div className="filters-box" ref={panelRef}>
      <div className="filter-item">
        <label className="filter-label">Job Category</label>
        <div
          className="custom-dropdown_filter multi-select"
          onClick={(e) => {
            if (
              e.target.classList.contains("custom-dropdown_filter") ||
              e.target.classList.contains("custom-dropdown-selected") ||
              e.target.closest(".custom-dropdown-selected")
            ) {
              setOpenDropdown(openDropdown === "jobCategory" ? null : "jobCategory");
            }
          }}
        >
          <div className="custom-dropdown-selected multi-input">
            <span className="placeholder-text">
              {filters.jobCategory.length === 0
                ? "Select job categories"
                : filters.jobCategory.length === 1
                  ? filters.jobCategory[0]
                  : `${filters.jobCategory[0]} + ${filters.jobCategory.length - 1} selected`}
            </span>
            <IoCaretDownSharp
              className={`dropdown-arrow ${openDropdown === "jobCategory" ? "rotate" : ""}`}
            />
          </div>

          {openDropdown === "jobCategory" && (
            <div
              className="custom-dropdown-options multi-options"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="search-box">
                <input
                  className="multi-select-input"
                  type="text"
                  placeholder="Search job categories"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>

              <div className="options-scroll">
                {[...filteredTags.filter(tag => filters.jobCategory.includes(tag)),
                ...filteredTags.filter(tag => !filters.jobCategory.includes(tag))
                ].map((option, idx) => (
                  <div
                    key={idx}
                    className={`custom-dropdown-option ${filters.jobCategory.includes(option) ? "selected" : ""
                      }`}
                    onClick={(e) => e.stopPropagation()}
                  >
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={filters.jobCategory.includes(option)}
                        onChange={() =>
                          filters.jobCategory.includes(option)
                            ? handleRemoveTag(option)
                            : handleSelectTag(option)
                        }
                      />
                      <span>{option}</span>
                    </label>
                  </div>
                ))}


                {filteredTags.length === 0 && (
                  <div className="custom-dropdown-option">No categories available</div>
                )}
              </div>


              {filters.jobCategory.length > 0 && (
                <div className="dropdown-bottom-bar">
                  <span className="job-count-info">{totalJobs} jobs available</span>
                  <button className="reset-btn" onClick={handleResetFilters}>
                    Reset Filters
                  </button>
                </div>
              )}
            </div>
          )}

        </div>
      </div>

      <div className="filter-item">
        <label className="filter-label">Job Posted Timeframe</label>
        <div
          className="custom-dropdown_filter"
          onClick={() =>
            setOpenDropdown(openDropdown === "timeframe" ? null : "timeframe")
          }
        >
          <div className="custom-dropdown-selected">
            {filters.timeframe}
            <IoCaretDownSharp
              className={`dropdown-arrow ${openDropdown === "timeframe" ? "rotate" : ""}`}
            />
          </div>
          {openDropdown === "timeframe" && (
            <div className="custom-dropdown-options">
              {["All Time", "Past 24 Hours", "Past Week", "Past Month"].map(
                (option, idx) => (
                  <div
                    key={idx}
                    className="custom-dropdown-option"
                    onClick={() => setFilters({ ...filters, timeframe: option })}
                  >
                    {option}
                  </div>
                )
              )}
            </div>
          )}
        </div>
      </div>

      <div className="filter-item">
        <label className="filter-label">City</label>
        <div
          className="custom-dropdown_filter"
          onClick={() =>
            setOpenDropdown(openDropdown === "city" ? null : "city")
          }
        >
          <div className="custom-dropdown-selected">
            {filters.city}
            <IoCaretDownSharp
              className={`dropdown-arrow ${openDropdown === "city" ? "rotate" : ""}`}
            />
          </div>
          {openDropdown === "city" && (
            <div className="custom-dropdown-options">
              {["Munich", "All", "Remote"].map((option, idx) => (
                <div
                  key={idx}
                  className="custom-dropdown-option"
                  onClick={() => setFilters({ ...filters, city: option })}
                >
                  {option}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
